import { Fragment, useState } from "react";
import { Loader } from "../../../../../UI/Loaders/Loaders";

import useGetAdminUser from "../../../hooks/useGetAdminUser";
import ToggleTab from "../../../../../NewComponents/ToggleTab/ToggleTab.component";
import DetailsTab from "./UserDetailTabs/DetailsTab.component";
import EditTab from "./UserDetailTabs/EditTab.component";
import LockHistoryTab from "./UserDetailTabs/LockHistoryTab.component";
import LockUnlockUserForm from "./LockUnlockUserForm.component";

export default function UserDetail({ dataRecord, onCloseModal }) {
  const [activeTab, setActiveTab] = useState("details");
  const [showLockUnlockForm, setShowLockUnlockForm] = useState(false);

  const { ssoUserId } = dataRecord;

  const {
    data: user,
    isLoading: isLoadingUserDetail,
    refetch,
  } = useGetAdminUser(ssoUserId);

  if (showLockUnlockForm) {
    return (
      <LockUnlockUserForm
        user={user}
        onBack={() => setShowLockUnlockForm(false)}
        onSuccess={() => {
          setShowLockUnlockForm(false);
          onCloseModal();
          refetch();
        }}
      />
    );
  }

  return (
    <Fragment>
      <h3 className="Modal__title p-b-2 text-center">User Information</h3>

      {isLoadingUserDetail || !user ? (
        <Loader centered={true} text="Loading user details..." />
      ) : (
        <>
          <div className="alignToggleTabItems mb-3 mt-4">
            <ToggleTab
              text="Details"
              id="details"
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
            <ToggleTab
              text="Edit"
              id="edit"
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
            <ToggleTab
              text="Lock History"
              id="lock-history"
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </div>

          {activeTab === "details" && (
            <DetailsTab
              user={user}
              onCloseModal={onCloseModal}
              onLockUnlock={() => setShowLockUnlockForm(true)}
            />
          )}

          {activeTab === "edit" && (
            <EditTab
              user={user}
              onBack={() => setActiveTab("details")}
              onUpdateSuccess={() => {
                refetch();
                setActiveTab("details");
              }}
            />
          )}

          {activeTab === "lock-history" && (
            <LockHistoryTab ssoUserId={ssoUserId} />
          )}
        </>
      )}
    </Fragment>
  );
}
